var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconScoreLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19664)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1058 11.1282C11.9418 13.8857 8.36968 21.9286 11.1272 29.0925C13.8847 36.2565 21.9276 39.8286 29.0915 37.0711C36.2555 34.3136 39.8276 26.2707 37.0701 19.1068C34.3126 11.9428 26.2697 8.37067 19.1058 11.1282ZM9.07414 29.8828C5.88021 21.585 10.0177 12.2691 18.3155 9.07513C26.6133 5.8812 35.9292 10.0187 39.1232 18.3165C42.3171 26.6143 38.1796 35.9302 29.8818 39.1242C21.584 42.3181 12.2681 38.1806 9.07414 29.8828Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1001 28C18.6001 30.8 21.1001 33 24.1001 33C27.1001 33 29.6001 30.8 30.1001 28H18.1001Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2566 27.2935C17.4656 27.0438 17.7744 26.8996 18.1 26.8996H30.1C30.4256 26.8996 30.7344 27.0438 30.9434 27.2935C31.1524 27.5431 31.2401 27.8725 31.1829 28.193C30.5911 31.5068 27.6439 34.0996 24.1 34.0996C20.5561 34.0996 17.6089 31.5068 17.0171 28.193C16.9599 27.8725 17.0476 27.5431 17.2566 27.2935ZM19.6102 29.0996C20.4212 30.7382 22.131 31.8996 24.1 31.8996C26.069 31.8996 27.7788 30.7382 28.5899 29.0996H19.6102Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6 19.0996C17.8075 19.0996 17.2 19.7071 17.2 20.4996V22.4996H15V20.4996C15 18.4921 16.5925 16.8996 18.6 16.8996C20.6075 16.8996 22.2 18.4921 22.2 20.4996V22.4996H20V20.4996C20 19.7071 19.3925 19.0996 18.6 19.0996Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6 19.0996C28.8075 19.0996 28.2 19.7071 28.2 20.4996V22.4996H26V20.4996C26 18.4921 27.5925 16.8996 29.6 16.8996C31.6075 16.8996 33.2 18.4921 33.2 20.4996V22.4996H31V20.4996C31 19.7071 30.3925 19.0996 29.6 19.0996Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.2,
    height: 32.2,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScoreLight);
export default __webpack_public_path__ + "static/media/icon_score_light.a639c965.svg";
export { ForwardRef as ReactComponent };